/**
 * @method getIsEndOfDocument
 * For the majority of cases scrollPercentage >= 1 means we're at the end of the document
 * We're using the scrollHeight, offsetHeight & scrollTop to catch edge cases
 * like a pdf being zoomed out & not filling the entire page
 * @param {Element} activeContainer
 * @param {number} scrollPercentage
 * @returns {boolean}
 */
const getIsEndOfDocument = (activeContainer, scrollPercentage) => {
  if (!activeContainer) {
    return null;
  }

  return (
    activeContainer.parentElement.scrollHeight ===
      activeContainer.parentElement.offsetHeight +
        activeContainer.parentElement.scrollTop || scrollPercentage >= 1
  );
};

export default getIsEndOfDocument;
